module.exports = __webpack_public_path__ + "static/media/Building.3f7d6d49.svg";